export default "__VITE_ASSET__Ca250fss__"